import PropTypes from 'prop-types';
// @mui
import { Grid } from '@mui/material';
import ShopProductCard from './ProductCard';

// ----------------------------------------------------------------------


export default function ProductList({ products, ...other }) {
  return (
    <Grid container spacing={2} {...other}>
      {products.map((product) => (
        <Grid key={product.id} item xs={12} sm={6} md={3}>
          <ShopProductCard product={product} />
		  
        </Grid>
      ))}
    </Grid>
  );
}
